<template>
<div class="bottombar">
  <div class="time">
    {{time}} | {{ countdown.days }}:{{ countdown.hours }}:{{ countdown.mins }}:{{ countdown.secs }}
  </div>
  <div class="total">
    {{ overlayData.donationTotal }}
  </div>
</div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'

  export default {
    name: 'countdown',
    mounted() {
      this.loadData()
      this.intervalHandle = setInterval(this.loadData(), 1000)
    },
    destroyed() {
      clearInterval(this.intervalHandle)
    },
    data () {
      return {
        overlayData: {},
        intervalHandle: null,
        time: '',
        currentTime: 0
      }
    },
    methods: {
      loadData () {
        axios.get(`/api/overlay/display`).then(({ data }) => {
          this.overlayData = data.overlay
        })
      }
    },
    computed: {
      countdown() {
        let secs = moment.utc(this.overlayData.startTime).diff(moment.utc(this.currentTime), 'seconds')

        if (secs < 0) secs = -secs

        let days = secs >= 86400 ? ~~(secs / 86400) : 0
        secs -= days * 86400

        let hours = secs >= 3600 ? ~~(secs / 3600) : 0
        secs -= hours * 3600

        let mins = secs >= 60 ? ~~(secs / 60) : 0
        secs -= mins * 60
        if (mins < 10) {
          mins = "0" + mins
        }
        if (secs < 10) {
          secs = "0" + secs
        }

        var today = new Date();
        var h = today.getHours();
        var m = today.getMinutes();
        var s = today.getSeconds();
        var ampm = 'AM'
        //Add 0's to make it look pretty
        if ( m < 10) {
          m = "0" + m
        }
        if ( s < 10) {
          s = "0" + s
        }
        //Determine AM/PM
        if (h > 11) {
          //Convert Military time to 12 hour variant
          if (h > 12) {
            h = h - 12
          }
          this.time = h + ":" + m + ":" + s + " PM"
        } else {
          this.time = h + ":" + m + ":" + s + " AM"
        }

        return { days, hours, mins, secs }
      }
    },
    created () {
      this.currentTime = new Date()
      setInterval(() => {
        this.currentTime = new Date()
      }, 1000)
    }
  }
</script>

<style scoped>
.bottombar {
  position:fixed;
  background-color:#282828;
  width:100vw;
  height:4.5vh;
  top:95.5vh;
  z-index:100;
}
.time {
  position:fixed;
  background-color:#FF3A3A;
  font-size:4vh;
  color:white;
  padding-left:1.5px;
  padding-right:3px;
  width:auto;
  height:4.5vh;
  top:95.5vh;
  left:0px;
}
.total {
  position:fixed;
  background-color:#FF3A3A;
  font-size:4vh;
  color:white;
  top:95.5vh;
  right:0px;
}

</style>



// WEBPACK FOOTER //
// src/components/Bottombar.vue